import MMIndex from '@/views/auth/media_manager/index.vue';
import { getI18nInstance } from '@/i18n';

export default [
    {
        path: '/mediamanager',
        name: 'media_manager',
        component: MMIndex,
        meta: {
            requiresAuth: true,
            title: () => getI18nInstance().t('media_manager'),
        },
    },
];
